import type { ProjecaoColetoresTabelaProps } from "./types-projecao-coletores-tabela";
import { useProjecaoColetoresTabela } from "./use-projecao-coletores-tabela";
import { ProjecaoColetoresTabelaView } from "./view-projecao-coletores-tabela";

export function ProjecaoColetoresTabela(props: ProjecaoColetoresTabelaProps) {
  const vm = useProjecaoColetoresTabela(props);

  return <ProjecaoColetoresTabelaView {...vm} />;
}

export type * from "./types-projecao-coletores-tabela";
